/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row4_LinearInputs */

const en_mk_cmp_row4_linear = /** @type {(inputs: Mk_Cmp_Row4_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separate, lives in Slack`)
};

const id_mk_cmp_row4_linear = /** @type {(inputs: Mk_Cmp_Row4_LinearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terpisah, lewat Slack`)
};

/**
* | output |
* | --- |
* | "Separate, lives in Slack" |
*
* @param {Mk_Cmp_Row4_LinearInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row4_linear = /** @type {((inputs?: Mk_Cmp_Row4_LinearInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row4_LinearInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row4_linear(inputs)
	return en_mk_cmp_row4_linear(inputs)
});